export const rankingItems = [
  {
    rank: 1,
    title: '长安十二时辰 第二季',
    category: '古装悬疑',
    heat: '986.5万',
    trend: 'up',
    desc: '马伯庸原著改编，易烊千玺、雷佳音主演，口碑爆款续作回归',
  },
  {
    rank: 2,
    title: '星际迷航：新纪元',
    category: '科幻大片',
    heat: '874.2万',
    trend: 'up',
    desc: '国产科幻新标杆，震撼视效打造浩瀚宇宙史诗',
  },
  {
    rank: 3,
    title: '我们的浪漫时光',
    category: '都市爱情',
    heat: '762.8万',
    trend: 'up',
    desc: '杨紫、肖战甜蜜搭档，夏日治愈系都市爱情剧',
  },
  {
    rank: 4,
    title: '暗夜追凶',
    category: '悬疑犯罪',
    heat: '698.3万',
    trend: 'down',
    desc: '烧脑推理层层反转，每集一个高能案件等你来破解',
  },
  {
    rank: 5,
    title: '山河令之重启',
    category: '武侠奇幻',
    heat: '621.7万',
    trend: 'up',
    desc: '经典武侠IP全新演绎，特效升级再现江湖恩怨',
  },
  {
    rank: 6,
    title: '极限挑战2026',
    category: '综艺真人秀',
    heat: '589.4万',
    trend: 'down',
    desc: '黄渤、孙红雷领衔新一季，笑点不断精彩不停',
  },
];

export const topicItems = [
  { name: '古装剧复兴', count: '12.8万', color: 'bg-primary-100 text-primary-700' },
  { name: '悬疑剧推荐', count: '9.6万', color: 'bg-accent-100 text-accent-800' },
  { name: '高分韩剧', count: '8.3万', color: 'bg-secondary-100 text-secondary-700' },
  { name: '国产科幻崛起', count: '7.5万', color: 'bg-primary-100 text-primary-700' },
  { name: '甜宠剧合集', count: '6.9万', color: 'bg-accent-100 text-accent-800' },
  { name: '经典港片重温', count: '5.4万', color: 'bg-secondary-100 text-secondary-700' },
  { name: '日剧精选', count: '4.8万', color: 'bg-primary-100 text-primary-700' },
  { name: '动画电影', count: '4.2万', color: 'bg-accent-100 text-accent-800' },
  { name: '高分纪录片', count: '3.7万', color: 'bg-secondary-100 text-secondary-700' },
  { name: '短剧合集', count: '3.1万', color: 'bg-primary-100 text-primary-700' },
  { name: '新剧速递', count: '2.8万', color: 'bg-accent-100 text-accent-800' },
];

export const commentItems = [
  {
    name: '追剧小达人',
    time: '2小时前',
    rating: 5,
    content: '用了小小影院快一年了，画质真的没得说！1080P超清在线观看还不缓冲，比好多收费平台都强。最近追《长安十二时辰》第二季体验特别好，推荐给所有剧荒的朋友！',
    likes: 328,
  },
  {
    name: '电影控老王',
    time: '5小时前',
    rating: 5,
    content: '作为一个老影迷，小小影院的片库真的让我惊喜。很多冷门经典港片都能找到高清版本，播放流畅不卡顿，而且完全免费不用注册，简直是宝藏站点。',
    likes: 256,
  },
  {
    name: '深夜剧迷',
    time: '1天前',
    rating: 4,
    content: '每天晚上必刷的观影平台，更新速度非常快，热门剧集基本都是同步更新。画质清晰流畅，手机和电脑都能看，体验很稳定。希望片库能越来越丰富！',
    likes: 189,
  },
  {
    name: '宅家小仙女',
    time: '2天前',
    rating: 5,
    content: '被闺蜜安利来的，一用就停不下来了！界面清爽没有乱七八糟的广告，资源也很全。最近在追几部韩剧都有高清资源，观影体验太好了，已经推荐给全宿舍了~',
    likes: 412,
  },
  {
    name: '科幻迷小陈',
    time: '3天前',
    rating: 5,
    content: '终于找到一个靠谱的免费高清影视平台了！《星际迷航：新纪元》这部国产科幻在小小影院看的，画质音效都很棒。不用下载任何播放器，浏览器直接看，太方便了。',
    likes: 175,
  },
];

export const mediaItems = [
  {
    title: '长安十二时辰 第二季',
    desc: '马伯庸原著改编古装悬疑巨制，易烊千玺再度饰演李必，揭开长安城中新的惊天阴谋。',
    tag: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20atmosphere%20with%20warm%20lantern%20lights%20in%20the%20night%2C%20traditional%20architecture%20silhouettes%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20mysterious%20and%20elegant%20mood%2C%20artistic%20film%20poster%20style%2C%20rich%20amber%20and%20crimson%20tones%2C%20clean%20composition&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '星际迷航：新纪元',
    desc: '国产科幻电影新高度，史诗级太空冒险，顶级特效团队打造震撼视觉体验。',
    tag: '即将上线',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20scene%20with%20stunning%20nebula%20colors%2C%20spaceship%20silhouette%20against%20cosmic%20backdrop%2C%20dramatic%20lighting%2C%20cinematic%20sci-fi%20aesthetic%2C%20deep%20space%20with%20warm%20star%20glow%2C%20epic%20movie%20poster%20composition%2C%20rich%20contrast&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '我们的浪漫时光',
    desc: '杨紫、肖战甜蜜主演，夏日海边小镇的治愈爱情故事，温暖整个夏天。',
    tag: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Warm%20summer%20seaside%20town%20with%20golden%20sunset%20light%2C%20two%20silhouettes%20walking%20on%20the%20beach%2C%20soft%20romantic%20atmosphere%2C%20dreamy%20cinematic%20lighting%2C%20pastel%20warm%20tones%2C%20artistic%20film%20poster%20style%2C%20gentle%20bokeh%20effect&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    title: '暗夜追凶',
    desc: '烧脑悬疑推理剧，每集独立案件层层反转，让你猜不到结局的高能犯罪剧。',
    tag: '高分推荐',
    image: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20mysterious%20atmosphere%2C%20noir%20cinematic%20style%2C%20deep%20shadows%20and%20dramatic%20contrast%2C%20warm%20streetlamp%20glow%2C%20suspenseful%20mood%2C%20film%20noir%20aesthetic%20composition&width=800&height=450&seq=media-04&orientation=landscape',
  },
  {
    title: '山河令之重启',
    desc: '经典武侠IP焕新演绎，顶级特效打造新江湖，恩怨情仇再度上演。',
    tag: '即将上线',
    image: 'https://readdy.ai/api/search-image?query=Majestic%20Chinese%20mountain%20landscape%20with%20mist%20and%20ancient%20temples%2C%20martial%20arts%20atmosphere%2C%20dramatic%20clouds%20and%20warm%20sunrise%20light%2C%20cinematic%20wuxia%20aesthetic%2C%20golden%20and%20crimson%20color%20palette%2C%20epic%20film%20poster%20composition&width=800&height=450&seq=media-05&orientation=landscape',
  },
];

export const cardItems = [
  {
    title: '2026年必看国产剧',
    desc: '整理了今年最值得追的国产好剧，从古装到现代，总有一部适合你。',
    category: '剧单推荐',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20cinematic%20scene%2C%20soft%20ambient%20lighting%2C%20comfortable%20atmosphere%2C%20modern%20home%20theater%20setup%2C%20warm%20golden%20and%20cream%20tones%2C%20relaxed%20evening%20vibe&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '韩剧高分榜TOP20',
    desc: '豆瓣8.5分以上韩剧合集，从《请回答1988》到最新热播剧。',
    category: '高分合集',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20with%20warm%20cafe%20setting%2C%20cherry%20blossom%20branches%20and%20soft%20spring%20light%2C%20cozy%20romantic%20atmosphere%2C%20pastel%20warm%20tones%2C%20artistic%20cinematic%20composition%2C%20gentle%20dreamy%20mood&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '周末电影马拉松',
    desc: '精选10部高分电影，从悬疑到喜剧，承包你的周末观影时光。',
    category: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Home%20movie%20night%20setup%20with%20popcorn%20and%20warm%20lighting%2C%20cozy%20blanket%20on%20sofa%2C%20cinematic%20glow%20from%20screen%2C%20comfortable%20relaxing%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20intimate%20evening%20vibe&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '国产科幻电影崛起',
    desc: '从《流浪地球》到《星际迷航：新纪元》，国产科幻的进化之路。',
    category: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20cityscape%20with%20advanced%20technology%20elements%2C%20warm%20sunset%20light%20over%20modern%20skyscrapers%2C%20sci-fi%20atmosphere%20with%20cinematic%20composition%2C%20rich%20golden%20and%20amber%20tones%2C%20epic%20scale&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '暑假动画片单',
    desc: '适合全家一起看的动画电影和剧集，大人小孩都会爱上。',
    category: '亲子观影',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20style%20scene%20with%20warm%20summer%20garden%2C%20playful%20atmosphere%2C%20soft%20golden%20sunlight%20through%20trees%2C%20whimsical%20and%20joyful%20mood%2C%20artistic%20illustration%20vibe%2C%20warm%20pastel%20color%20palette&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '悬疑剧迷必看清单',
    desc: '烧脑悬疑剧合集，从国产到海外，每一部都让你欲罢不能。',
    category: '类型精选',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20library%20or%20study%20room%20with%20warm%20lamp%20light%2C%20old%20books%20and%20shadows%2C%20detective%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20warm%20amber%20glow%20in%20dark%20setting%2C%20suspenseful%20but%20elegant%20mood&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export const carouselItems = [
  {
    title: '暑期档爆款合集',
    desc: '这个夏天最火爆的影视剧都在这里，从古装大片到现代甜宠，日均更新20+部高清资源，让你追剧追到停不下来。',
    tag: '热门专题',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20atmosphere%20with%20warm%20vibrant%20colors%2C%20abstract%20film%20projection%20light%20beams%2C%20artistic%20theater%20ambiance%2C%20golden%20and%20warm%20amber%20gradients%2C%20cinematic%20composition%20with%20soft%20glow%2C%20elegant%20movie%20premiere%20vibe&width=1200&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '豆瓣高分华语剧',
    desc: '精选豆瓣8.0分以上华语剧集，古装悬疑、都市情感、年代大剧一网打尽，高清画质畅享优质内容。',
    tag: '高分精选',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20traditional%20and%20modern%20fusion%20aesthetic%2C%20ink%20wash%20painting%20style%20with%20warm%20tones%2C%20artistic%20film%20poster%20composition%2C%20soft%20gradients%20of%20cream%20and%20crimson%2C%20cultural%20atmosphere%2C%20cinematic%20mood&width=1200&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '新用户观影指南',
    desc: '初次来到小小影院？这里有最快上手指南：无需注册直接播放、1080P超清画质、海量片库每日更新，马上开始你的高清追剧之旅。',
    tag: '新手上路',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20with%20cinematic%20display%2C%20comfortable%20seating%2C%20cozy%20atmosphere%2C%20warm%20cream%20and%20golden%20tones%2C%20inviting%20and%20relaxing%20vibe&width=1200&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '经典港片重温计划',
    desc: '周星驰、成龙、王家卫...那些年我们追过的经典港片，高清修复版本已上线，带你重温黄金年代的港片记忆。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20street%20scene%20with%20warm%20neon%20signs%2C%20vintage%20cinema%20aesthetic%2C%20rain-slicked%20pavement%20reflecting%20golden%20light%2C%20classic%20film%20atmosphere%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20nostalgia&width=1200&height=500&seq=carousel-04&orientation=landscape',
  },
];

export const faqItems = [
  {
    q: '小小影院真的完全免费吗？需要注册吗？',
    a: '是的，小小影院完全免费，无需注册即可在线观看所有内容。我们致力于为影迷提供无门槛的高清观影体验，打开网站就能直接看，没有任何隐藏费用。',
  },
  {
    q: '视频画质怎么样？支持高清播放吗？',
    a: '我们提供最高1080P超清画质的影视资源，大部分热门剧集和电影都支持高清在线观看。播放流畅不缓冲，画质清晰细腻，给您影院级的观影享受。',
  },
  {
    q: '资源更新速度快吗？能看最新剧集吗？',
    a: '我们的内容团队每日更新，热门剧集基本实现同步更新。新剧上线后最快2小时内即可在小小影院找到高清资源，保证您不错过任何精彩内容。',
  },
  {
    q: '支持手机和平板观看吗？',
    a: '当然支持！小小影院采用响应式设计，完美适配手机、平板和电脑。无论您在通勤路上还是在家休息，随时随地都能享受流畅的高清观影体验。',
  },
  {
    q: '有广告吗？观影体验会不会被打断？',
    a: '小小影院始终坚持清爽的观影体验，页面无弹窗广告、无强制广告。我们相信好的观影平台应该让用户专注于内容本身，不被无关信息打扰。',
  },
];

export const indexItems = [
  { name: '国产剧', icon: 'ri-tv-line', count: '2,860部', desc: '古装、都市、悬疑、年代剧全覆盖' },
  { name: '韩国剧', icon: 'ri-heart-line', count: '1,520部', desc: '高分韩剧、最新热播一网打尽' },
  { name: '欧美剧', icon: 'ri-global-line', count: '2,340部', desc: '美剧英剧精选，字幕高清同步' },
  { name: '动作片', icon: 'ri-fire-line', count: '1,890部', desc: '枪战、武打、冒险大片合集' },
  { name: '喜剧片', icon: 'ri-emotion-laugh-line', count: '1,650部', desc: '国内外爆笑喜剧欢乐不断' },
  { name: '爱情片', icon: 'ri-heart-2-line', count: '1,420部', desc: '浪漫爱情电影，甜蜜治愈心灵' },
  { name: '科幻片', icon: 'ri-rocket-line', count: '1,280部', desc: '硬核科幻、太空冒险视觉盛宴' },
  { name: '恐怖片', icon: 'ri-ghost-line', count: '980部', desc: '经典恐怖惊悚，胆大者入' },
  { name: '纪录片', icon: 'ri-film-line', count: '1,750部', desc: '自然、历史、人文深度纪实' },
];

export const updateItems = [
  {
    date: '2026-07-31',
    title: '《长安十二时辰》第二季第8集高清上线',
    desc: '最新一集已更新，易烊千玺、雷佳音精彩演绎，古装悬疑再掀高潮。',
  },
  {
    date: '2026-07-30',
    title: '《我们的浪漫时光》大结局超前点映上线',
    desc: '杨紫、肖战甜蜜收官，这个夏天最治愈的爱情故事完美落幕。',
  },
  {
    date: '2026-07-29',
    title: '新增50部经典港片高清修复版',
    desc: '周星驰、成龙、周润发经典作品高清修复，重温港片黄金年代。',
  },
  {
    date: '2026-07-28',
    title: '《暗夜追凶》本周更新两集连播',
    desc: '第14、15集同步上线，案件升级反转不断，烧脑指数拉满。',
  },
  {
    date: '2026-07-27',
    title: '日剧频道新增《重启人生》全季',
    desc: '豆瓣9.4分高分日剧，安藤樱主演，温暖治愈的奇幻人生故事。',
  },
  {
    date: '2026-07-26',
    title: '《极限挑战2026》第三期全程高能',
    desc: '黄渤、孙红雷爆笑互动，本期挑战沙漠极限生存，笑到停不下来。',
  },
  {
    date: '2026-07-25',
    title: '网站画质全面升级至1080P超清',
    desc: '技术团队完成CDN节点扩容，全国范围内高清播放更流畅不缓冲。',
  },
  {
    date: '2026-07-24',
    title: '动画电影频道上线，百部佳作免费看',
    desc: '宫崎骏、新海诚等知名导演作品高清上线，适合全家人一起观看。',
  },
];

export const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '1080P超清画质',
    desc: '全站高清资源，画质细腻色彩饱满，带给您影院级的视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '全球CDN加速节点覆盖，智能选路技术确保播放过程零卡顿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无需注册',
    desc: '打开即看，无需填写任何个人信息，真正做到零门槛免费观影。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '专业内容团队24小时值守，热门影视资源第一时间同步上线。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '手机、平板、电脑无缝切换，随时随地享受流畅的高清观影体验。',
  },
];

export const heroStats = [
  { label: '高清片源', value: '32,000+' },
  { label: '日均更新', value: '50+' },
  { label: '日均访客', value: '120万+' },
];